export default {
  data() {
    return {
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: this.$t('button.skip'),
          buttonPrevious: this.$t('button.previous'),
          buttonNext: this.$t('button.next'),
          buttonStop: this.$t('button.close'),
        },
      },
      tourSteps: [],
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/tour.js